import React, { useState, useEffect, useCallback } from 'react'
import { I18n } from 'react-redux-i18n'
import { toastMessage } from 'utils/messages'

import { credentialAPI } from 'api'
import TimeAndDate from 'utils/TimeAndDate'
import TimerSelector from 'components/common/TimerSelector'


function PaymentLinkExpire(props) {
  const [state, setState] = useState({ time: 0, unit: "minutes" })
  const [disabled, setDisabled] = useState(false)

  useEffect(() => {
    credentialAPI.getLinkExpireTime()
      .then(({ data }) => {
        const rigthTime = TimeAndDate.millisecondsToUnit({ unit: "minutes", ...data })
        setState(rigthTime)
      })
      .catch(() => {
        setState({
          time: 0,
          unit: 'minutes'
        })
      })
  }, [])

  const onSubmit = () => {
    const timeToExpire = TimeAndDate.timeToMilliseconds({ unit: "minutes", ...state })

    setDisabled(true)

    credentialAPI.postLinkExpireTime(timeToExpire)
      .then(() => {
        toastMessage(I18n.t('toast_credential_limit_expire_time'))
      })
      .finally(() => {
        setDisabled(false)
      })
  }

  const onChange = useCallback((data) => {
    setState(data)
  }, [])

  return (
    <div style={{ marginBottom: 23 }}>
      <TimerSelector
        label={I18n.t('label_credential_limit_unit_selector')}
        defaultValue={state}
        value={state}
        onChange={onChange}
        exclude={['seconds']}
        onClickSave={onSubmit}
        disabled={disabled}
      />
    </div>
  )
}

export default PaymentLinkExpire